export default function BlurredZeroValue({ value, suffix }) {
	return <span style={{ opacity: value == 0 ? '0.2' : '1' }}>{value}{suffix}</span>;
}